import { IconPropsType } from '..';

export const IncrementIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="kb-core-icon">
      <path
        id="Vector"
        d="M11.1998 6.71325H7.788V3.30005H6.213V6.71325H2.7998V8.28825H6.213V11.7H7.788V8.28825H11.1998V6.71325Z"
      />
    </g>
  </svg>
);
